import ManuLayout from '@/components/layout/MenuLayout'

export default {
  created() {
    this.$parent.$emit('layout', ManuLayout)
  },
  render() {
    return this.$slots.default[0]
  },
}
